import { Typography } from "@mui/material";
import React from "react";
import { StyledAnimatedLoader, StyledLoaderWrapper } from "./styles";

const Loader = ({ color, fullPage = false, absolute = false, showText, textColor='', hideBg = true }) => {
  return (
    <StyledLoaderWrapper $fullPage={fullPage} $absolute={absolute} $hideBg={hideBg}>
      <StyledAnimatedLoader $color={color}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </StyledAnimatedLoader>
      {showText && <Typography variant="h6" fontWeight="medium" color={textColor}>
        {showText}
      </Typography>}
    </StyledLoaderWrapper>
  );
};

export default Loader;
